function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var H = Object.defineProperty;
var o = Object.getOwnPropertySymbols;
var r = Object.prototype.hasOwnProperty,
    d = Object.prototype.propertyIsEnumerable;

var t = function t(l, e, C) {
  return e in l ? H(l, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: C
  }) : l[e] = C;
},
    n = function n(l, e) {
  for (var C in e || (e = {})) {
    r.call(e, C) && t(l, C, e[C]);
  }

  if (o) {
    var _iterator = _createForOfIteratorHelper(o(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var C = _step.value;
        d.call(e, C) && t(l, C, e[C]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return l;
};

import * as i from "react";

function v(l) {
  return i.createElement("svg", n({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, l), i.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11.5 10H15V8H13V7H11V8.051C9.86 8.283 9 9.293 9 10.5C9 11.878 10.122 13 11.5 13H12.5C12.776 13 13 13.225 13 13.5C13 13.776 12.776 14 12.5 14H9V16H11V17H13V15.95C14.14 15.718 15 14.707 15 13.5C15 12.122 13.878 11 12.5 11H11.5C11.224 11 11 10.776 11 10.5C11 10.225 11.224 10 11.5 10Z",
    fill: "black"
  }));
}

export { v as ReactComponent };